import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {CommonService} from '../../../services/common.service';
import {ExcelService} from '../../../services/excel.service';
import {ReportService} from '../../../services/report.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {ReportReminderDialogComponent} from '../../shared/report-reminder-dialog/report-reminder-dialog.component';
import {CustomFormRemindersDialogComponent} from '../custom-form-reports/custom-form-reminders-dialog/custom-form-reminders-dialog.component';

@Component({
    selector: 'app-custom-form-parent-reports',
    templateUrl: './custom-form-parent-reports.component.html',
    styleUrls: ['./custom-form-parent-reports.component.scss']
})
export class CustomFormParentReportsComponent implements OnInit {
    isLoading: boolean;
    pendingReminderRequest: boolean;
    forms: any[] = [];
    originalForms: any[] = [];
    completed: number;
    finalForms: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    displayColumns = ['title', 'published_at', 'completed', 'pending', 'reminder', 'actions'];

    constructor(private reportService: ReportService,
                public excelService: ExcelService,
                public router: Router,
                public dialog: MatDialog,
                private commonService: CommonService,
                public toastMessagesService: ToastMessagesService) {
        this.isLoading = true;
        this.completed = 0;
        this.pendingReminderRequest = false;
    }

    async ngOnInit() {
        await this.initReports();
    }

    async initReports() {
        try {
            this.isLoading = true;
            this.pendingReminderRequest = true;
            console.log('[Tab2 - Προσωπικές δηλώσεις χρηστών] Fetching custom forms parent report...');
            this.originalForms = await this.reportService.getCustomFormsParentsReport();
            console.log('[Tab2 - Προσωπικές δηλώσεις χρηστών] Response:', this.originalForms);
            console.log('[Tab2 - Προσωπικές δηλώσεις χρηστών] Total forms count:', this.originalForms?.length || 0);
            for (const form of this.originalForms) {
                if (this.forms.findIndex(an => an.uniqueId === form.uniqueId) === -1) {
                    form.p_date = Date.parse(form.published_datetime);
                    form.reminder_sent = '';
                    form.reminder_date = null;
                    this.forms.push(form);
                }
            }

            this.forms = this.forms.sort((a, b) => b.p_date - a.p_date);
            this.finalForms = new MatTableDataSource<any>(this.forms);

            this.isLoading = false;

            const promises = [];
            this.finalForms.data.forEach(form => promises.push(this.commonService.getList(`reports/parent-reminder-date?uniqueId=${form.uniqueId}`)));
            const results = await Promise.all(promises);
            results.forEach((request, index) => {
                if (request.object.action_date) {
                    this.finalForms.data[index].reminder_date = request.object.action_date;
                    this.finalForms.data[index].reminder_sent = request.object.reminder_sent;
                } else {
                    this.finalForms.data[index].reminder_sent = '-';
                }
            });

            this.pendingReminderRequest = false;


            // for (const form of this.forms) {
            //   const request = await this.commonService.getList(`reports/parent-reminder-date?uniqueId=${form.uniqueId}`);
            //   if (request.object.action_date) {
            //     form.reminder_date = request.object.action_date;
            //     form.reminder_sent = request.object.reminder_sent;
            //   } else {
            //     form.reminder_sent = '-';
            //   }
            // }

        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
        }
    }

    async sendNotification(reportAnnouncement: any) {
        try {
            const uniqueId = reportAnnouncement.uniqueId;

            const request = await this.commonService.getList(`reports/getParentFormReportUsers?uniqueId=${reportAnnouncement.uniqueId}`);
            const records = request.object;

            const completed = records.filter(record => record.status === 1);
            const pending = records.filter(record => record.status === 0);

            const emails = {completed, pending};

            this.dialog.open(ReportReminderDialogComponent, {
                height: '100vh',
                // panelClass: 'full-screen-modal',
                data: {
                    mode: 10,
                    uniqueId,
                    emails
                }
            });
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async exportToExcel(reportAnnouncement: any) {
        const uniqueFormId = reportAnnouncement.uniqueId;
        console.log(reportAnnouncement);
        try {
            const data = await this.reportService.getParentDataToExport(uniqueFormId);

            const columns = this.commonService.formatColumns(data[0]);
            const resultData = [];
            for (const d of data) {
                resultData.push(this.commonService.formatData(d));
            }
            this.excelService.exportAsCustomExcelFile(resultData, reportAnnouncement.title, columns);

        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async showCompleted(form) {
        console.log(form);
        await this.router.navigate(['home/completed-parent-forms-details'], {queryParams: {formUniqueId: form.uniqueId}});
    }

    calculateOpened(formUniqueId: any) {
        const announcements = this.originalForms.filter(announcement => announcement.uniqueId === formUniqueId);
        const totalSent = announcements.length;
        const completed = announcements.filter(form => form.status === 1).length;
        this.completed = completed;
        const result = (completed / totalSent) * 100;
        const percentage = Math.round(result);

        if (percentage === 0) {
            return `(${percentage}%)`;
        } else {
            return `${completed}/${totalSent} (${percentage}%)`;
        }
    }

    calculatePending(formUniqueId: any) {
        const announcements = this.originalForms.filter(announcement => announcement.uniqueId === formUniqueId);
        const totalSent = announcements.length;
        const notOpened = announcements.filter(form => form.status === 0).length;
        const result = (notOpened / totalSent) * 100;
        const percentage = Math.round(result);

        if (percentage === 0) {
            return `(${percentage}%)`;
        } else {
            return `${notOpened}/${totalSent} (${percentage}%)`;
        }
    }

    showRemindersInfo(reportAnnouncement: any) {
        this.dialog.open(CustomFormRemindersDialogComponent, {
            data: {
                uniqueId: reportAnnouncement.uniqueId,
                title: reportAnnouncement.title,
                mode: 2
            }
        });
    }
}
